import axiosPrivate from "@services/axiosPrivate";

export const getPostPayBill = (payload) => {
    return axiosPrivate.post(`/getPostPayBill`, payload);
};